/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { extractStyleAsNumber } from '../../../utilities/helpers';

const ModalBodyLayout = ({
  children = null,
  renderFooter = null,
  renderTitle = null,
  renderLTVPopup = null,
  renderHeader = null,
  title = null,
  renderRightTitle = null,
  withBack = null,
  onPrevClick = null,
  isScrollable = true,
  isButtonInFooter = false,
  scrollStyle = null,
  isIframe = false,
  className = '',
  fixedFooter = false,
}) => {
  const [contentMaxHeight, setContentMaxHeight] = useState('20rem');
  const scrollHostRef = useRef();
  const titleRef = useRef();
  const footerRef = useRef();
  const headerRef = useRef();

  const calculateContentSize = () => {
    // this needs to be rewritten using refs but that requires either handling passing props on so many files or ideally refactoring of the modal component and subscomponents

    const footer = document.querySelector('.modal-footer');
    const footerMarginTop = footer ? extractStyleAsNumber(footer, 'marginTop') : 0;
    const footerMarginBottom = footer ? extractStyleAsNumber(footer, 'marginBottom') : 0;

    // header from the header inside modal body. Not to be confused with the outer header
    const modalBodyHeader = document.querySelector('.modal-body-header');
    const modalBodyHeaderMarginBottom = modalBodyHeader
      ? extractStyleAsNumber(modalBodyHeader, 'marginBottom')
      : 0;
    const modalBodyHeaderPaddingBottom = modalBodyHeader
      ? extractStyleAsNumber(modalBodyHeader, 'paddingBottom')
      : 0;

    const modalTitle = document.querySelector('.modal-title');
    const titlePaddingMarginTop = modalTitle ? extractStyleAsNumber(modalTitle, 'marginTop') : 0;
    const titlePaddingMarginBottom = modalTitle
      ? extractStyleAsNumber(modalTitle, 'marginBottom')
      : 0;

    // <Modal> parent
    const modal = document.querySelector('.modal');
    const modalPaddingTop = modal ? extractStyleAsNumber(modal, 'paddingTop') : 0;
    const modalMarginTop = modal ? extractStyleAsNumber(modal, 'marginTop') : 0;
    const modalMarginBottom = modal ? extractStyleAsNumber(modal, 'marginBottom') : 0;
    const modalPaddingBottom = modal ? extractStyleAsNumber(modal, 'paddingBottom') : 0;

    // <Modal> content
    const modalContent = document.querySelector('.modal-content');
    const modalContentPaddingTop = modalContent
      ? extractStyleAsNumber(modalContent, 'paddingTop')
      : 0;
    const modalContentMarginBottom = modalContent
      ? extractStyleAsNumber(modalContent, 'marginBottom')
      : 0;
    const modalContentPaddingBottom = modalContent
      ? extractStyleAsNumber(modalContent, 'paddingBottom')
      : 0;

    // header from <ModalHeader>
    const modalHeader = document.querySelector('.modal-content');
    const modalHeaderMarginTop = modalHeader ? extractStyleAsNumber(modalHeader, 'marginTop') : 0;
    const modalHeaderMarginBottom = modalHeader
      ? extractStyleAsNumber(modalHeader, 'marginBottom')
      : 0;

    // header from <ModalBody>
    const modalBody = document.querySelector('.modal-body');
    const modalBodyMarginTop = modalBody ? extractStyleAsNumber(modalBody, 'marginTop') : 0;
    const modalBodyMarginBottom = modalBody ? extractStyleAsNumber(modalBody, 'marginBottom') : 0;

    return (
      window.innerHeight -
      (footerMarginTop +
        footerMarginBottom +
        (footer?.clientHeight || 0) +
        modalBodyHeaderMarginBottom +
        modalBodyHeaderPaddingBottom +
        (modalBodyHeader?.clientHeight || 0) +
        titlePaddingMarginTop +
        titlePaddingMarginBottom +
        (modalTitle?.clientHeight || 0) +
        modalPaddingTop +
        modalMarginTop +
        modalMarginBottom +
        modalPaddingBottom +
        modalContentPaddingTop +
        modalContentMarginBottom +
        modalContentPaddingBottom +
        modalHeaderMarginTop +
        modalHeaderMarginBottom +
        modalBodyMarginTop +
        modalBodyMarginBottom)
    );
  };
  useEffect(() => {
    if (isMobile && isScrollable) {
      // make the height of the content part of the modal dynamic based on the heights of the footer, title and header to avoid cropped modals and keep the footer buttons fixed
      const res = calculateContentSize();
      setContentMaxHeight(`${res + 150}px`);
    } else {
      setContentMaxHeight(renderFooter ? '34.5rem' : '39rem');
    }
  }, [children, window.innerHeight]);

  return (
    <>
      <div ref={titleRef} className={`flex-row-center  ${className} pe-3 pe-md-5`}>
        <div
          className={`modal-title d-flex flex-row ${
            withBack ? 'cursor-pointer text-hover' : 'w-100'
          }`}
          onClick={withBack ? onPrevClick : null}
          onKeyDown={withBack ? onPrevClick : null}
          role="presentation">
          {withBack && (
            <i className="icon icon-arrow-back-navigation text-f4 me-2" aria-label="Back" />
          )}
          {renderTitle ? renderTitle() : <b className="text-f5 me-auto">{title}</b>}

          {renderLTVPopup !== null ? renderLTVPopup() : ''}
        </div>
        {renderRightTitle && renderRightTitle()}
      </div>
      {renderHeader && (
        <div ref={headerRef} className="modal-body-header pe-3 pe-md-5">
          {renderHeader()}
        </div>
      )}
      {isIframe && children}
      {!isIframe && (
        <>
          {/* mobile layout */}
          <div className="d-flex flex-column d-md-none pe-3 flex-fill mt-4" ref={scrollHostRef}>
            {children}
          </div>

          {/* browser layout */}
          <div
            className={`d-none d-md-block pe-5 mb-3 ${isScrollable ? 'scrollable-content' : ''}`}
            style={{
              height: renderFooter || isButtonInFooter ? 'auto' : '100%',
              position: isButtonInFooter ? 'unset' : 'relative',
              maxHeight: `${contentMaxHeight}`,
              flex: 1,
              ...scrollStyle,
            }}
            ref={scrollHostRef}>
            {children}
          </div>
        </>
      )}
      {renderFooter ? (
        <>
          {/* mobile layout */}
          <div
            ref={footerRef}
            className={`d-block d-md-none modal-footer border-0 pe-3 py-3 ${
              fixedFooter ? 'position-fixed w-95 bottom-0 bg-grey-lighter' : ''
            }`}
            style={{ bottom: 0 }}>
            <div className="row d-flex justify-content-center w-100">{renderFooter()}</div>
          </div>

          {/* browser layout */}
          <div
            ref={footerRef}
            className={`d-none d-md-block modal-footer border-0 pe-5 ${
              fixedFooter ? 'position-fixed w-95 bottom-0 bg-grey-lighter' : ''
            }`}
            style={{ bottom: 0 }}>
            <div className="row d-flex justify-content-center w-100">{renderFooter()}</div>
          </div>
        </>
      ) : null}
    </>
  );
};
export default ModalBodyLayout;

ModalBodyLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  withBack: PropTypes.bool,
  renderFooter: PropTypes.func,
  title: PropTypes.string,
  renderRightTitle: PropTypes.func,
  onPrevClick: PropTypes.func,
  renderTitle: PropTypes.func,
  renderLTVPopup: PropTypes.func,
  renderHeader: PropTypes.func,
  isScrollable: PropTypes.bool,
  isButtonInFooter: PropTypes.bool,
  scrollStyle: PropTypes.object,
  isIframe: PropTypes.bool,
  className: PropTypes.string,
  fixedFooter: PropTypes.bool,
};
